<template>
  <div class="OrderList">
    <el-table
        :row-style="tableRowClassName"
        :data="list"
        height="600"
        border
        class="order_table">
      <el-table-column
          prop="order_state_text"
          label="State"
          width="90">
      </el-table-column>
      <el-table-column
          prop="order_id"
          label="Order ID"
          width="170">
      </el-table-column>
      <el-table-column
          prop="product_name_en"
          label="Product Name"
          width="200">
      </el-table-column>
      <el-table-column
          prop="count"
          label="Qty"
          width="60">
      </el-table-column>
      <el-table-column
          prop="pay_amount"
          label="Payment"
          width="100">
      </el-table-column>
      <el-table-column
          prop="balance_amount"
          label="Balance"
          width="100">
      </el-table-column>
      <el-table-column
          prop="order_time"
          label="Order Time"
          width="150">
      </el-table-column>
      <el-table-column
          prop="order_address"
          label="Shipping Address"
          width="280">
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <el-button
              size="mini"
              style="width: 70px"
              @click="onView(scope.row.order_id)">View
          </el-button>
          <el-button
              size="mini"
              style="width: 70px"
              type="primary"
              @click="onManage(scope.row.order_id)">Action
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog class="dialog" custom-class="popup_detail" title="Order Detail" :visible.sync="dialog_detail_visible">
      <OrderDetail v-if="dialog_detail_visible" :orderid="current_id"></OrderDetail>
    </el-dialog>
    <el-dialog class="dialog" custom-class="popup_manage" title="Manage Order" :visible.sync="dialog_manage_visible">
      <OrderManage v-if="dialog_manage_visible" :orderid="current_id"></OrderManage>
    </el-dialog>

  </div>
</template>

<script>
  import OrderDetail from "@/components/Orders/OrderDetail/OrderDetail";
  import OrderManage from "@/components/Orders/OrderManage/OrderManage";

  export default {
    components:{
      OrderDetail,
      OrderManage
    },
    props: ['list'],
    data: () => {
      return {
        dialog_detail_visible:false,
        dialog_manage_visible:false,
        current_id:'',
      }
    },
    watch:{
      dialog_manage_visible:function (n) {
        if (!n){
          this.$emit('refresh')
        }
      }
    },
    methods: {
      tableRowClassName({row}) {
        if (row.order_state_text === 'Pending') {
          return 'background: #f0f9eb';
        }
        return '';
      },
      onView(order_id) {
        this.current_id = order_id;
        this.dialog_detail_visible = true
      },
      onManage(order_id) {
        this.current_id = order_id;
        this.dialog_manage_visible = true
      },
    },

  };
</script>


<style lang="scss">
  @import "_OrderList.scss";
</style>